import React, { useContext as useContextCore } from 'react'
import { useChatMessageListByUserEmail } from '@ztechapps/chat.common'
import type { UseListResult } from '@ztechapps/common.hook'
import type { Chat } from '@ztechapps/common.contract'
import { useUser } from '../../../../hooks/useUser'

export type MessageListProviderProps = {
  children: React.ReactNode
}

export type MessageListContext = {
  chatListResult: UseListResult<Chat>
} & Omit<MessageListProviderProps, 'children'>

const context = React.createContext<MessageListContext>({} as MessageListContext)
const CoreProvider = context.Provider

export const MessageListProvider = ({ children, ...props }: MessageListProviderProps) => {
  const { user } = useUser()
  const email = user?.profile?.email

  const chatListResult = useChatMessageListByUserEmail({ email })

  return <CoreProvider value={{ ...props, chatListResult }}>{children}</CoreProvider>
}

export const useMessageListContext = () => useContextCore(context)
